// BattleEnd.jsx
import React from "react";
import battle1 from "../../assets/images/Battles/battle1.png";
import { useSelector } from "react-redux";
import { routes } from "../../routes";
import { useNavigate } from "react-router-dom";
import "./battleEnd.css";
import {ReactComponent as Swords} from "../../assets/icons/swords.svg";
import battle2 from "../../assets/images/Battles/battle2.png";
import Crown from "../../assets/icons/crown.png";
const BattleEnd = ({ player1, player2, onReplay, isReplaying }) => {
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const navigate = useNavigate();

  const winner = player1?.winner ? player1 : player2;
  const winnerAvatar = winner?.user?.userdetails?.avatar || battle1;
  const winnerName =
    winner?.user?.userdetails?.username ||
    winner?.user?.username ||
    "Player";
  const winnerAmount = winner?.total_amount
    ? parseFloat(winner.total_amount.toFixed(2))
    : 0;

  return (
    <div className="btlEnd__wrapper">
      {/* Blurred background items */}
      <div  className="btlEnd__bgItems">
        <div style={{filter:"blur(20px)"}}>
        <h1 className="battle-ended-text">Battle has ended</h1>
        <div className="mt-4 battle-end-icons">
          <div className="battle-end-icons-details">
            <div
              className="avatar_div"
            >
              <img
                style={{ height: "100%", width: "100%" }}
                src={
                  player1?.user?.userdetails?.avatar
                    ? `${player1?.user?.userdetails?.avatar}`
                    : battle1
                }
                alt="Player 1"
              />
            </div>
            <span style={{ color: isDarkMode ? "white" : "black" }}>
              {player1.user?.userdetails?.username 
    || player1.user?.username 
    || "Player 1"}
            </span>
            <span
              style={{
                color: player1?.winner ? "#06B6C7" : "#FF6F67",
                display: "block",
                textAlign: "center",
              }}
            >
              $
              {player1?.winner
                ? parseFloat(player1?.total_amount.toFixed(5)) || 0
                : "0.0"}
            </span>
          </div>
          <Swords style={{ width: "32px", height: "32px" }} />
          <div className="battle-end-icons-details">
            <div
              className="avatar_div"
            >
              <img
                style={{ height: "100%", width: "100%" }}
                src={
                  player2?.userdetails?.avatar
                    ? player2.userdetails.avatar
                    : player2?.user?.userdetails?.avatar
                      ? player2.user.userdetails.avatar
                      : battle2
                }
                alt="Player 2"
              />
            </div>
            <span style={{ color: isDarkMode ? "white" : "black" }}>
              {player2.user?.userdetails?.username || player2.user?.username || "Player 2"}
            </span>
            <span
              style={{
                color: player2?.winner ? "#06B6C7" : "#FF6F67",
                display: "block",
                textAlign: "center",
              }}
            >
              $
              {player2?.winner
                ? parseFloat(player2?.total_amount.toFixed(5)) || 0
                : "0.0"}
            </span>
          </div>
        </div>
</div>
      </div>

      {/* Winner Card */}
      <div className="btlEnd__card">
        <h1 className="btlEnd__title text-AktivGrotesk-Bold">WINNER</h1>

        <div className="btlEnd__winner">
          <div className="btlEnd__avatarWrap">
            <img
              src={winnerAvatar}
              alt={winnerName}
              className="btlEnd__avatarImg"
            />
            <div className="btlEnd__crown">
              <img src={Crown} alt="crown" />
            </div>
          </div>
          <div className="btlEnd__info">
            <span className="btlEnd__name text-AktivGrotesk-Bold">{winnerName}</span>
            <span className="btlEnd__amount">${winnerAmount}</span>
          </div>
        </div>

        <div className="btlEnd__btns">
          <button
            className="btlEnd__btnBack text-AktivGrotesk-Bold"
            onClick={() => navigate(routes.BATTLES)}
          >
            Back to Battles
          </button>
          <button
            className="btlEnd__btnReplay text-AktivGrotesk-Bold"
            onClick={onReplay}
            disabled={isReplaying}
          >
            {isReplaying ? "Replaying..." : "Replay"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BattleEnd;